// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Nh-g","rotate":"Spinner_rotate__33MoV"};